import { v4 as uuidv4 } from 'uuid';
import { assignPublisherColors } from '../../../../commons/utils/publisherColors';
import { getDiscoverPublishersAPI } from './api';
import fallbackData from './data/directory-publishers.json';
import staticIndustries from './data/directory-industries.json';

const DISPLAY_LIMIT = 50;

async function getDirectoryPublishers() {
    const session = this.env.session;
    const traceId = this.env.traceId;

    // Load industry filter buttons immediately from static list
    this.directoryFilterIndustries = staticIndustries;
    this.observed.directoryPublishers = uuidv4();

    // --- Page 1: render immediately ---
    const firstRes = await getDiscoverPublishersAPI({ token: session?.token, traceId, page: 1 });
    const firstData = firstRes?.data?.data || firstRes?.data || null;
    const firstPublishers = firstData?.publishers || [];
    const totalPages = firstData?.totalPages || 1;

    if (firstPublishers.length === 0) {
        this.masterDirectoryPublishers = fallbackData.publishers;
        this.directoryPublishers = fallbackData.publishers.slice(0, DISPLAY_LIMIT);
        this.directoryFilterIndustries = fallbackData.filterIndustries || [];
        this.observed.directoryPublishers = uuidv4();
        return;
    }

    const colored = assignPublisherColors(firstPublishers);
    this.masterDirectoryPublishers = colored;
    this.directoryPublishers = colored.slice(0, DISPLAY_LIMIT);
    this.observed.directoryPublishers = uuidv4();

    if (totalPages <= 1) return;

    // --- Remaining pages: fetch in background, update master list silently ---
    for (let page = 2; page <= totalPages; page++) {
        const res = await getDiscoverPublishersAPI({ token: session?.token, traceId, page });
        const data = res?.data?.data || res?.data || null;
        const publishers = data?.publishers || [];
        if (publishers.length === 0) break;

        this.masterDirectoryPublishers = [...this.masterDirectoryPublishers, ...assignPublisherColors(publishers)];
        this.observed.directoryPublishers = uuidv4();
    }
}

export default getDirectoryPublishers;
